import {
  DISTRIBUTION_GROUP_MARKDOWN,
  MENTION_TYPE,
  TAG_MARKDOWN,
  USER_MARKDOWN,
} from "modules/utils/Constants";

interface DeltaOp {
  insert: string | { mention: { id: string; type: string } };
  attributes?: Record<string, any>;
}

class DeltaBuilder {
  private ops: DeltaOp[] = [];

  text(value: string, attributes?: Record<string, any>) {
    this.ops.push({ insert: value, ...(attributes && { attributes }) });
    return this;
  }

  mention(id: string, type: MENTION_TYPE) {
    this.ops.push({
      insert: { mention: { id, type } },
    });
    this.ops.push({ insert: " " });
    return this;
  }

  newline() {
    this.ops.push({ insert: "\n" });
    return this;
  }

  build(): string {
    // Ensure trailing newline
    const lastOp = this.ops[this.ops.length - 1];
    if (!lastOp || lastOp.insert !== "\n") {
      this.ops.push({ insert: "\n" });
    }
    return JSON.stringify({ ops: this.ops });
  }

  toPlainText(): string {
    let result = "";

    for (const op of this.ops) {
      if (typeof op.insert === "string") {
        result += op.insert;
      } else if (op.insert?.mention) {
        const { id, type } = op.insert.mention;
        switch (type) {
          case MENTION_TYPE.USER:
            result += `{{${USER_MARKDOWN}=${id}}}`;
            break;
          case MENTION_TYPE.DISTRIBUTION_GROUP:
            result += `{{${DISTRIBUTION_GROUP_MARKDOWN}=${id}}}`;
            break;
          case MENTION_TYPE.TAG:
            result += `{{${TAG_MARKDOWN}=${id}}}`;
            break;
          default:
            break;
        }
      }
    }

    return result;
  }
}

export default DeltaBuilder;
